module.exports = __webpack_public_path__ + "static/img/smaco-7.74fb0d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/smaco-7.jpg
// module id = TJeV
// module chunks = 1